import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CelumPropertiesProvider } from '@celum/core';
import { SproProcess } from '@celum/formats/domain';
import { BYPASS_GLOBAL_HTTP_ERROR_HANDLING } from '@celum/shared/shared';

import { FormatsContextAware } from './formats-context-aware';

/**
 * Single implementation of process-related API calls shared by the standalone `formats` app and the `formats-embed`
 * app. The environment-specific concerns (tenant resolution, authentication headers for embedded calls) are handled
 * by `FormatsContextAware` based on the `FORMATS_CONTEXT` provided where this service is registered.
 */
@Injectable()
export class ProcessService extends FormatsContextAware {
  private http = inject(HttpClient);

  public getProcess(processId: string): Observable<SproProcess> {
    return this.withContext(
      context =>
        this.http.get<SproProcess>(`${CelumPropertiesProvider.properties.appProperties.formats.processApiUrl}/admin/processes/${processId}`, { context }),
      // process-view shows an inline error (e.g. "process not found") for failed lookups, so the host application's
      // generic HTTP-error handling (which would otherwise redirect away on 403/404) is bypassed here.
      new HttpContext().set(BYPASS_GLOBAL_HTTP_ERROR_HANDLING, true)
    );
  }

  public getProcessZip(processId: string): Observable<Blob> {
    return this.withContext(
      context =>
        this.http.get(`${CelumPropertiesProvider.properties.appProperties.formats.processApiUrl}/admin/processes/${processId}/data`, {
          context,
          responseType: 'blob'
        }),
      new HttpContext().set(BYPASS_GLOBAL_HTTP_ERROR_HANDLING, true)
    );
  }
}
